
namespace Matrix.Data {

	export interface ClientEntityOptions {
		module: string;
		identifier: string;
		idProperty: string;
        nameProperty: string;
        quickSearch: boolean;
	}

	@Serenity.Decorators.registerClass()
	export class ClientEntityGrid extends SiteEntityGrid<any, ClientEntityOptions> {
		protected getColumnsKey() { return this.options.module + "." + this.options.identifier; }
		protected getDialogType() { return ClientEntityDialog; }
		protected getIdProperty() { return this.options.idProperty; }
		protected getLocalTextPrefix() { return this.options.module + "." + this.options.identifier; }
		protected getService() { return this.options.module + "/" + this.options.identifier; }

		constructor(container: JQuery, options: ClientEntityOptions) {
			super(container, options);
		}

		protected createEntityDialog(itemType: string, callback?: (dlg: Serenity.Widget<any>) => void): Serenity.Widget<any> {

			if (!itemType || itemType == this.getItemType()) {
				return new ClientEntityDialog(this.options).init(d => {
					this.initEntityDialog(itemType, d);
					callback && callback(d);
				});
			}

			return super.createEntityDialog(itemType, callback);
        }

        protected createQuickSearchInput() {
            if (this.options.quickSearch)
                super.createQuickSearchInput();
        }
	}

}